import { FC } from 'react'
import { Panel } from '../components/ui/Panel'
import { PageTitle } from '../components/ui/PageTitle'
import { homeData } from '../data'
import { HomeCtas } from '../components/HomeCtas'
import eventPoster2026Nov from 'url:../assets/event-posters/2026-11-21-event-poster.png'
import instagramIcon from 'url:../assets/icons/instagram.png'
import facebookIcon from 'url:../assets/icons/facebook.png'
import youtubeIcon from 'url:../assets/icons/youtube.png'
import tiktokIcon from 'url:../assets/icons/tiktok.png'

/** Home page with overview, about, and playlist embed. */
const Home: FC = () => {
  return (
    <div className='space-y-8'>
      <HomeCtas placement='inline' />

      <Panel>
        <div className='grid gap-6 md:grid-cols-[minmax(0,320px)_1fr] md:items-stretch'>
          <div className='h-full overflow-hidden rounded-xl bg-brand-smoky/70'>
            <img
              src={eventPoster2026Nov}
              alt='Event poster'
              loading='lazy'
              className='h-full w-full object-contain'
            />
          </div>
          <div>
            <PageTitle as='h2'>{homeData.aboutHeading}</PageTitle>
            <div className='mt-4 space-y-3 text-brand-azure/80 md:text-lg'>
              {homeData.aboutParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </Panel>

      <Panel>
        <PageTitle as='h2'>{homeData.playlistHeading}</PageTitle>
        <p className='mt-3 text-brand-azure/80 md:text-lg'>{homeData.featuredPlaylistDescription}</p>
        <div className='mt-4 flex h-[520px] overflow-hidden rounded-xl bg-brand-smoky/80 shadow-[0_12px_30px_rgba(0,0,0,0.35)] ring-1 ring-black/20 sm:h-[440px] md:h-[440px] lg:h-[520px]'>
          <iframe
            title='Slava Ukraine: Metal Fundraiser featured playlist'
            src={homeData.featuredPlaylistEmbedUrl}
            width='100%'
            height='100%'
            frameBorder='0'
            allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
            loading='lazy'
            className='block h-full w-full flex-1'
          />
        </div>
      </Panel>

      <Panel>
        <div className='flex w-full flex-wrap items-center gap-4'>
          <PageTitle as='h2' className='flex-1 min-w-[12rem]'>
            Find us on
          </PageTitle>
          <div className='flex items-center gap-4 w-full sm:w-auto'>
            <a
              className='social-icon'
              href='https://www.instagram.com/slavaukraine.metal/'
              rel='noreferrer'
              target='_blank'
              aria-label='Instagram'
            >
              <img src={instagramIcon} alt='Instagram' className='h-8 w-8' />
            </a>
            <a
              className='social-icon'
              href='https://www.facebook.com/profile.php?id=100088172091793&rdid=bvjGsMHdCOfsyll6&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1LJzy9P17N%2F#'
              rel='noreferrer'
              target='_blank'
              aria-label='Facebook'
            >
              <img src={facebookIcon} alt='Facebook' className='h-8 w-8' />
            </a>
            <a
              className='social-icon'
              href='https://tr.ee/I2lrJ__UBm'
              rel='noreferrer'
              target='_blank'
              aria-label='YouTube'
            >
              <img src={youtubeIcon} alt='YouTube' className='h-8 w-8' />
            </a>
            <a
              className='social-icon'
              href='https://tr.ee/bIaMc3EXPS'
              rel='noreferrer'
              target='_blank'
              aria-label='TikTok'
            >
              <img src={tiktokIcon} alt='TikTok' className='h-8 w-8' />
            </a>
          </div>
        </div>
      </Panel>
    </div>
  )
}

export default Home
